import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { Languages } from "types/localization";
import { getLocalStorageItem } from "../utils/localStorage";

export const makeLangUrl = (url: string): string => {
  const lang = getLocalStorageItem(STORAGE_LANGUAGE_NAME);
  const langUrlPrefix =
    lang.toLowerCase() === Languages.EN ? "" : `/${lang.toLowerCase()}`;
  const fullUrl = url === `${langUrlPrefix}/` ? url : `${langUrlPrefix}/${url}`;
  return fullUrl.replace(/([^:]\/)\/+/g, "$1").replace("//", "/");
};
